import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@devinforius/i-essentials';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TreeSelect } from 'primeng/treeselect';
import { MultipleStatutesDTO } from 'src/app/shared/models/iCourrier/status-management/multiple-statutes';
import { GroupsGlobalDto } from 'src/app/shared/interfaces';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { MultipleStatutesService } from 'src/app/shared/services/multiple-statutes.service';

@Component({
  selector: 'app-create-new-tag',
  templateUrl: './create-new-tag.component.html',
  styleUrls: ['./create-new-tag.component.scss'],
})
export class CreateNewTagComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect: TreeSelect;

  public form: UntypedFormGroup = new UntypedFormGroup({
    description: new UntypedFormControl(null, Validators.required),
    ordreAffichage: new UntypedFormControl(null),
    color: new UntypedFormControl('#000000'),
    notUsed: new UntypedFormControl(true),
    servicesAuthorized: new UntypedFormControl([]),
    cocherAjouterDroitAccesGroupeID: new UntypedFormControl(null),
    courrierActionDroitCocherGroupeID: new UntypedFormControl(null),
    courrierActionDroitDecocherGroupeID: new UntypedFormControl(null),
  });

  //list of datas recovered from other component
  public serviceParent = [];
  public flattenedServices = [];

  // datas used in component
  public isLoaded = false;
  private translationPlaceholderPTree = '';
  public groups = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public toastr: ToastrService,
    public translater: TranslateService,
    private spinner: NgxSpinnerService,
    private multipleStatutesService: MultipleStatutesService,
    private groupsService: GroupsService
  ) {
    if (this.config) {
      this.serviceParent = this.config.data.serviceParent;
      this.flattenedServices = this.config.data.flattenedServices;
    } else {
      this.toastr.error(this.translater.translate('errorOccurred'));
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
    this.getGroups();
  }

  getGroups(): void {
    this.groups = [];
    this.groupsService.fetchGlobalGroups().subscribe({
      next: (res) => {
        if (res.length > 0) {
          res.forEach((item) => {
            this.groups.push({ label: item.description, value: item.id });
          });
        }
        this.isLoaded = true;
        this.spinner.hide();
      },
    });
  }

  select(): void {
    if (this.treeSelect.value.find((x) => x.key === 'inforiusCheckAllForServices')) {
      this.treeSelect.value = this.flattenedServices.concat({
        label: '',
        value: 'inforiusCheckAllForServices',
        parentId: null,
        name: '',
        key: 'inforiusCheckAllForServices',
        selectable: true,
        children: [],
      });

      this.setPlaceholderServiceTreeSelect();
    } else {
      if (this.treeSelect.value.length === this.flattenedServices.length) {
        this.treeSelect.value = this.treeSelect.value.concat({
          label: '',
          name: '',
          key: 'inforiusCheckAllForServices',
          value: 'inforiusCheckAllForServices',
          selectable: true,
          children: [],
        });
      }
      this.setPlaceholderServiceTreeSelect();
    }
    this.form.patchValue({
      servicesAuthorized: this.treeSelect.value.filter((x) => x.key !== 'inforiusCheckAllForServices').map((x) => x.value),
    });
  }

  unselect(event): void {
    if (event.node.key === 'inforiusCheckAllForServices') {
      this.treeSelect.value = [];
      this.setPlaceholderServiceTreeSelect();
      this.form.patchValue({
        servicesAuthorized: [],
      });
    } else {
      const indexCheckAll = this.treeSelect.value.map((x) => x.key).indexOf('inforiusCheckAllForServices');
      if (indexCheckAll > -1) {
        this.treeSelect.value.splice(indexCheckAll, 1);
      }
      this.setPlaceholderServiceTreeSelect();
      this.form.patchValue({
        servicesAuthorized: this.treeSelect.value.filter((x) => x.key !== 'inforiusCheckAllForServices').map((x) => x.value),
      });
    }
  }

  setPlaceholderServiceTreeSelect(): void {
    let amountOfSelectedServices = '';
    if (this.treeSelect.value.length === 0) {
      amountOfSelectedServices = this.translationPlaceholderPTree;
    } else if (this.treeSelect.value.length === 1) {
      amountOfSelectedServices = this.treeSelect.value[0].label;
    } else {
      const totalOfSelectedServices = this.treeSelect.value.filter((x) => x.key !== 'inforiusCheckAllForServices').length;
      if (totalOfSelectedServices === this.flattenedServices.length) {
        amountOfSelectedServices = this.translater.translate('allServicesChecked', {
          value: totalOfSelectedServices,
        });
      } else {
        amountOfSelectedServices = this.translater.translate('xServicesChecked', {
          value: totalOfSelectedServices,
        });
      }
    }
    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
    labelTreeHtml[0].innerHTML = amountOfSelectedServices;
  }

  submit(): void {
    if (this.form.valid) {
      this.form.value.notUsed = !this.form.value.notUsed;
      if (this.form.value.servicesAuthorized === null) {
        this.form.value.servicesAuthorized = [];
      }
      this.multipleStatutesService.postManagementMultipleStatus(this.form.value).subscribe({
        next: (res: MultipleStatutesDTO) => {
          this.toastr.success(this.translater.translate('tagsInfos.tagCreated'));
          this.ref.close(res);
        },
      });
    } else {
      this.toastr.error(this.translater.translate('pleaseFulfillRequiredFields'));
    }
  }
}
